import { FC } from 'react';
import { Asset } from './dto/Asset';
import './AssetImageColumn.scss';
import { apiUrl } from '../constants';

interface Props {
  item: Asset;
}

export const AssetImageColumn: FC<Props> = ({ item }) => {
  return item.imageUrl ? (
    <a
      className="AssetImageColumn"
      href={apiUrl + item.imageUrl}
      target="_blank"
      style={{
        backgroundImage: `url(${apiUrl + item.imageUrl})`,
      }}
      rel="noreferrer"
    />
  ) : null;
};
